import { Box, CircularProgress, Typography } from "@mui/material"
import { createFileRoute } from "@tanstack/react-router"
import type { FC } from "react"

import { TransferType } from "@/graphql/codegen/graphql"
import { TransferFormPage } from "@/screens/Inventory/subfeatures/Transfers/components/TransferFormPage/TransferFormPage"
import { useGetTransfer } from "@/screens/Inventory/subfeatures/Transfers/hooks/useGetTransfer"

const TransferEditPage: FC = () => {
  const { transferId } = Route.useParams()
  const { transfer, isFetching } = useGetTransfer(transferId)

  if (!transfer) {
    return (
      <Box className='flex h-full items-center justify-center'>
        {isFetching ? <CircularProgress size={48} /> : <Typography>Transfer not found</Typography>}
      </Box>
    )
  }

  return (
    <TransferFormPage
      type={transfer.transferType}
      sourceWarehouseArea={transfer.sourceWarehouseArea}
      targetWarehouseArea={
        transfer.transferType === TransferType.InterWarehouse ? transfer.targetWarehouseArea : undefined
      }
      transfer={transfer}
    />
  )
}

export const Route = createFileRoute("/app/inventory/transfers/$transferId/edit")({
  component: TransferEditPage,
})
